import React from "react";
import "./AnimatedText.css"; // Importing our CSS file

const AnimatedText = () => {
  return (
    <div className="animated-text-container">
      <span className="animated-text">Let's Do It!</span>
    </div>
  );
};

export default AnimatedText;
